import * as moment from 'moment';
import { Pomodoro } from './Pomodoro';
import { Sound } from './Sound.model';
import { TaskService } from '../services/task.service';
import { Setting } from './setting.model';
import { CategoryService } from '../services/category.service';
import {
  Directive,
  ElementRef,
  Injector,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { SoundService } from '../services/sound.service';
import { SettingService } from '../services/setting.service';
import { NotificationService } from '../services/notification.service';
import { PushNotificationsService } from 'ng-push-ivy';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { OnlineService } from '../services/online.service';
import { Category } from './category.model';
import { Todo } from './todo.model';
import { TodoService } from '../services/todo.service';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export class PomodoroRepository {
  protected constructor(private injector: Injector) {
    this.categoryService = injector.get(CategoryService);
    this.taskService = injector.get(TaskService);
    this.todoService = injector.get(TodoService);
    this.soundService = injector.get(SoundService);
    this.settingService = injector.get(SettingService);
    this.ngNotification = injector.get(PushNotificationsService);
    this.translateService = injector.get(TranslateService);
    this.onlineService = injector.get(OnlineService);
    this.renderer = injector.get(Renderer2);
    this.router = injector.get(Router);
    this.getSumOfDurationsDone();
    const token = localStorage.getItem('token');
    this.haveToken = token !== null;
    if (token !== null) {
      this.userIsLoggedIn = true;
      this.login = 'خروج';
    } else {
      this.userIsLoggedIn = false;
      this.login = 'ورود';
    }
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translateService.setDefaultLang('fa');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    // this.translateService.use('fa');
    if (localStorage.getItem('trans') === 'en') {
      this.translateService.use('en');
      this.ltrDirection = true;
      this.defaultFlag = 'assets/image/english.png';
      this.defaultFlagName = 'English';
    }
    if (localStorage.getItem('trans') === 'fa') {
      this.translateService.use('fa');
      this.ltrDirection = false;
      this.defaultFlag = 'assets/image/persian.png';
      this.defaultFlagName = 'فارسی';
    }
    if (localStorage.getItem('trans') === 'ar') {
      this.translateService.use('ar');
      this.defaultFlag = 'assets/image/arabic.png';
      this.defaultFlagName = 'العربیة';
      this.ltrDirection = false;
      this.arabicMode = true;
    }
    if (localStorage.getItem('trans') === 'du') {
      this.translateService.use('du');
      this.defaultFlag = 'assets/image/german.png';
      this.defaultFlagName = 'Deutsch';
      this.ltrDirection = true;
      this.germanMode = true;
    }
    if (localStorage.getItem('trans') === 'hi') {
      this.translateService.use('hi');
      this.defaultFlag = 'assets/image/indian.png';
      this.defaultFlagName = 'हिन्दी\n';
      this.ltrDirection = true;
    }
    if (localStorage.getItem('trans') === 'ru') {
      this.translateService.use('ru');
      this.defaultFlag = 'assets/image/russian.png';
      this.defaultFlagName = 'Русский';
      this.ltrDirection = true;
      this.spRuMode = true;
    }
    if (localStorage.getItem('trans') === 'sp') {
      this.translateService.use('sp');
      this.defaultFlag = 'assets/image/spanish.png';
      this.defaultFlagName = 'Español';
      this.ltrDirection = true;
      this.spRuMode = true;
    }
    localStorage.setItem('trans', 'fa');

    if (localStorage.getItem('isReverse') === null) {
      this.isReversed = 'بالا به پایین';
    } else {
      this.isReversed = localStorage.getItem('isReverse');
    }

    this.todoPomodoros = JSON.parse(
      localStorage.getItem('todoPomodoros') !== 'undefined'
        ? localStorage.getItem('todoPomodoros')
        : '[]'
    );
    this.todoPomodoros = this.todoPomodoros ? this.todoPomodoros : [];

    // tslint:disable-next-line:max-line-length
    this.todoPomodorosTopToBottom = JSON.parse(
      localStorage.getItem('todoPomodorosTopToBottom') !== 'undefined'
        ? localStorage.getItem('todoPomodorosTopToBottom')
        : '[]'
    );
    this.todoPomodorosTopToBottom = this.todoPomodorosTopToBottom
      ? this.todoPomodorosTopToBottom
      : [];
    // tslint:disable-next-line:max-line-length
    this.todoPomodorosBottomToTop = JSON.parse(
      localStorage.getItem('todoPomodorosBottomToTop') !== 'undefined'
        ? localStorage.getItem('todoPomodorosBottomToTop')
        : '[]'
    );
    this.todoPomodorosBottomToTop = this.todoPomodorosBottomToTop
      ? this.todoPomodorosBottomToTop
      : [];

    // this.todoPomodorosTopToBottom = this.todoPomodoros.sort((a, b) => (a.id < b.id) ? -1 : 1);
    // this.todoPomodorosBottomToTop = this.todoPomodoros.sort((a, b) => (a.id > b.id) ? -1 : 1);

    const dp = localStorage.getItem(
      'donePomodoros_' + moment().format('YYYY-MM-DD')
    );
    this.donePomodoros = JSON.parse(dp !== 'undefined' ? dp : '[]');
    this.donePomodoros = this.donePomodoros ? this.donePomodoros : [];

    // this.pomoSounds = JSON.parse(localStorage.getItem('myPomoSound') !== 'undefined' ? localStorage.getItem('myPomoSound') : '[]');
    // this.pomoSounds = this.pomoSounds ? this.pomoSounds : [];

    let d = this.pomodoroSound;
    this.pomodoroSound = JSON.parse(localStorage.getItem('apiPomoSound'));
    this.pomodoroSound = this.pomodoroSound ? this.pomodoroSound : d;
    this.pomodoroAudio.src = this.pomodoroSound.url;

    d = this.breakSound;
    this.breakSound = JSON.parse(localStorage.getItem('apiBreakSound'));
    this.breakSound = this.breakSound ? this.breakSound : d;
    this.breakAudio.src = this.breakSound.url;

    if (localStorage.getItem('BreakSoundsList') === null) {
      const breakStringify = JSON.stringify(this.breakSoundsInNoneLoginMode);
      this.breakSoundsInNoneLoginMode = JSON.parse(breakStringify);
    } else if (localStorage.getItem('BreakSoundsList') !== null) {
      this.breakSoundsInNoneLoginMode = JSON.parse(
        localStorage.getItem('BreakSoundsList')
      );
    }

    if (localStorage.getItem('PomodoroSoundsList') === null) {
      const pomoStringify = JSON.stringify(this.pomoSoundsInNoneLoginMode);
      this.pomoSoundsInNoneLoginMode = JSON.parse(pomoStringify);
    } else if (localStorage.getItem('PomodoroSoundsList') !== null) {
      this.pomoSoundsInNoneLoginMode = JSON.parse(
        localStorage.getItem('PomodoroSoundsList')
      );
    }

    if (localStorage.getItem('apiPomoSound') === null) {
      const pomoStringify = JSON.stringify(this.pomoSounds);
      this.pomoSounds = JSON.parse(pomoStringify);
    } else if (localStorage.getItem('apiPomoSound') !== null) {
      this.pomoSounds = JSON.parse(localStorage.getItem('apiPomoSound'));
    }

    if (localStorage.getItem('apiBreakSound') === null) {
      const breakStringify = JSON.stringify(this.breakSounds);
      this.breakSounds = JSON.parse(breakStringify);
    } else if (localStorage.getItem('apiBreakSound') !== null) {
      this.breakSounds = JSON.parse(localStorage.getItem('apiBreakSound'));
    }

    if (localStorage.getItem('defaultMeasure') === null) {
      this.defaultMeasure = 25;
    } else {
      // tslint:disable-next-line:radix
      this.defaultMeasure = parseInt(localStorage.getItem('defaultMeasure'));
    }
    if (localStorage.getItem('shortBreak') === null) {
      this.shortBreak = 5;
    } else {
      // tslint:disable-next-line:radix
      this.shortBreak = parseInt(localStorage.getItem('shortBreak'));
    }
    if (localStorage.getItem('longBreak') === null) {
      this.longBreak = 20;
    } else {
      // tslint:disable-next-line:radix
      this.longBreak = parseInt(localStorage.getItem('longBreak'));
    }
    if (localStorage.getItem('defaultPomoCount') === null) {
      this.defaultCount = 4;
    } else {
      // tslint:disable-next-line:radix
      this.defaultCount = parseInt(localStorage.getItem('defaultPomoCount'));
    }
    if (localStorage.getItem('language') === null) {
      this.germanMode = true;
    } else {
      // tslint:disable-next-line:radix
      this.germanMode = parseInt(localStorage.getItem('language')) === 1;
    }
    if (localStorage.getItem('darkMode') === null) {
      this.darkMode = false;
    } else {
      // tslint:disable-next-line:radix
      this.darkMode = parseInt(localStorage.getItem('darkMode')) === 1;
    }
    if (localStorage.getItem('arrangeAddingTasks') === null) {
      this.arrangeAddingTasks = 'به اول لیست کارها';
      localStorage.setItem('arrangeAddingTasks', this.arrangeAddingTasks);
    } else {
      // tslint:disable-next-line:radix
      this.arrangeAddingTasks = localStorage.getItem('arrangeAddingTasks');
    }

    if (localStorage.getItem('autoNextBreak') === null) {
      this.autoNextBreak = true;
    } else {
      // tslint:disable-next-line:radix
      this.autoNextBreak =
        parseInt(localStorage.getItem('autoNextBreak')) === 1;
    }

    if (localStorage.getItem('autoNextPomodoro') === null) {
      this.autoNextPomodoro = false;
    } else {
      // tslint:disable-next-line:radix
      this.autoNextPomodoro =
        parseInt(localStorage.getItem('autoNextPomodoro')) === 1;
    }
    if (localStorage.getItem('sendPomodoroNotification') === null) {
      this.sendPomodoroNotification = false;
    } else {
      // tslint:disable-next-line:radix
      this.sendPomodoroNotification =
        parseInt(localStorage.getItem('sendPomodoroNotification')) === 1;
    }
    if (localStorage.getItem('sendRestNotification') === null) {
      this.sendRestNotification = false;
    } else {
      // tslint:disable-next-line:radix
      this.sendRestNotification =
        parseInt(localStorage.getItem('sendRestNotification')) === 1;
    }
    if (localStorage.getItem('beInPomodoroRanking') === null) {
      this.beInPomodoroRanking = false;
    } else {
      // tslint:disable-next-line:radix
      this.beInPomodoroRanking =
        parseInt(localStorage.getItem('beInPomodoroRanking')) === 1;
    }

    const cc = localStorage.getItem('categories');
    this.categories = JSON.parse(cc !== 'undefined' ? cc : '[]');
    this.categories = this.categories ? this.categories : [];

    if (this.isLoggedIn()) {
      this.taskService.getListOfUsersTask().subscribe((data) => {
        this.todoPomodoros = data.data.todo;
        this.todoPomodorosTopToBottom = this.todoPomodoros.sort((a, b) =>
          a.id < b.id ? -1 : 1
        );
        this.todoPomodorosBottomToTop = this.todoPomodoros.sort((a, b) =>
          a.id > b.id ? -1 : 1
        );
        this.donePomodoros = data.data.done;
        this.save(false);
      });
      this.todoService.getListOfUsersTodo().subscribe((data) => {
        this.todosList = data.data;
      });
      this.settingService.getSettingInformation().subscribe((data) => {
        this.getSettingId = data.data.getSettingId;
        this.defaultMeasure = data.data.pomodoro_time_length;
        this.shortBreak = data.data.short_rest_time;
        this.longBreak = data.data.long_rest_time;
        this.defaultCount = data.data.pomodoro_count_after_long_rest;
        this.autoNextPomodoro = data.data.start_next_pomodoro_automatic;
        this.autoNextBreak = data.data.start_next_rest_automatic;
        this.sendPomodoroNotification = data.data.send_pomodoro_notification;
        this.sendRestNotification = data.data.send_rest_notification;
        this.beInPomodoroRanking = data.data.be_in_pomodoro_ranking;
        if (data.data.pomodoro_sound === null) {
          this.pomodoroSoundId = 1;
        } else {
          this.pomodoroSoundId = data.data.pomodoro_sound.id;
        }
        if (data.data.rest_sound === null) {
          this.restSoundId = 2;
        } else {
          this.restSoundId = data.data.rest_sound.id;
        }
        this.save(false);
      });

      this.categoryService.getListOfUsersCategory().subscribe((data) => {
        this.categories = data;
        this.save(false);
      });
      // this.soundService.getListOfSound().subscribe(
      //   (data) => {
      //     this.pomoSounds = data.data;
      //     localStorage.setItem('apiPomoSound', JSON.stringify(this.pomoSounds));
      //     this.breakSounds = data.data;
      //     localStorage.setItem('apiBreakSound', JSON.stringify(this.breakSounds));
      //     console.log(this.breakSounds);
      //   });
      // this.getSoundFromApi();
    }
    if (localStorage.getItem('isPremium') === null) {
      this.isPremium = 'false';
    } else {
      // tslint:disable-next-line:radix
      this.isPremium = localStorage.getItem('isPremium');
    }

    if (localStorage.getItem('index') === null) {
      this.index = 1;
    } else {
      // tslint:disable-next-line:radix
      this.index = parseInt(localStorage.getItem('index'));
    }

    if (localStorage.getItem('categoryIndex') === null) {
      this.categoryIndex = 1;
    } else {
      // tslint:disable-next-line:radix
      this.categoryIndex = parseInt(localStorage.getItem('categoryIndex'));
    }

    if (localStorage.getItem('isBreak') === null) {
      this.isBreak = false;
    } else {
      // tslint:disable-next-line:radix
      this.isBreak = parseInt(localStorage.getItem('isBreak')) === 1;
    }
    if (localStorage.getItem('status') === null) {
      this.status = 'stop';
    } else {
      this.status = localStorage.getItem('status');
    }

    if (
      localStorage.getItem(
        'todayPomodoroCount_' + moment().format('YYYY-MM-DD')
      ) === null
    ) {
      this.todayPomodoroCount = 1;
    } else {
      // tslint:disable-next-line:radix
      this.todayPomodoroCount = parseInt(
        localStorage.getItem(
          'todayPomodoroCount_' + moment().format('YYYY-MM-DD')
        )
      );
    }

    if (localStorage.getItem('endTimestamp') === null) {
      this.endTimestamp = 0;
    } else {
      // tslint:disable-next-line:radix
      this.endTimestamp = parseInt(localStorage.getItem('endTimestamp'));
    }

    if (localStorage.getItem('donePomodorosWhileTimeCounting') === null) {
      this.donePomodorosWhileTimeCounting = 0;
    } else {
      // tslint:disable-next-line:radix
      this.donePomodorosWhileTimeCounting = parseInt(
        localStorage.getItem('donePomodorosWhileTimeCounting')
      );
    }

    if (typeof Worker !== 'undefined') {
      const worker = new Worker('../app.worker.ts', { type: 'module' });
      worker.onmessage = () => {
        this.intervalFunction();
      };
    }
    this.save(false);
    // this.taskService.getListOfUsersTask().subscribe(
    //   (data) => {
    //     this.todoPomodoros = data.data;
    //   }
    // );
  }

  protected static instance: PomodoroRepository = null;
  @ViewChild('categoryInput', { static: false }) categoryInput: ElementRef;
  @ViewChild('descriptionInput', { static: false })
  descriptionInput: ElementRef;
  @ViewChild('tasksList') tasksList: ElementRef;
  public selectedBreakSound: any;
  public selectedPomoSound: any;
  public myArray = [1, 10, 19, 27, 34];
  public userIsLoggedIn;
  public tcp;
  public login;
  public controller: any = false;
  public getCategory;
  public pomoCount: any;
  public sendPomodoroNotification = true;
  public sendRestNotification = true;
  public beInPomodoroRanking: any = false;
  public pomodoroSoundId = 1;
  public restSoundId = 1;
  public getSettingId: number;
  public status;
  public endTimestamp;
  public isBreak = false;
  public darkMode = false;
  public interval;
  public time;
  public todayPomodoroCount: number;
  public startDisable = true;
  public todoPomodoros: Pomodoro[];
  public todoPomodorosTopToBottom: Pomodoro[];
  public todoPomodorosBottomToTop: Pomodoro[];
  public donePomodoros: Pomodoro[];
  public isReversed = 'بالا به پایین';
  public todosList = [];
  public todoListIds = [];
  public pomodoro: Pomodoro;
  public index: number;
  public categoryIndex;
  public today = Date.now();
  public startTime: any = null;
  public remainTest: any;
  public defaultMeasure = 25;
  public shortBreak = 5;
  public longBreak = 20;
  public donePomodorosWhileTimeCounting = 0;
  public timerRemain;
  public pomodoroRemains;
  public defaultCount = 4;
  public autoNextPomodoro = false;
  public autoNextBreak = true;
  public userID = localStorage.getItem('userId');
  public profilePhoto;
  public categories: any;
  public editCtrl;
  public apiCategoryName = [];
  public todaySumHour;
  public getTodayProp;
  public finalDone;
  public clickToggle = false;
  public arabicMode = false;
  public germanMode = false;
  public spRuMode = false;
  public haveToken = false;
  public allCategory = 'همه دسته بندی ها';
  public isMenuOpen = true;
  public startTour = false;
  public ctlOne = false;
  public ctlTwo = false;
  public ctlThree = false;
  public ctlFour = false;
  public ctlFive = false;
  public ctlSix = false;
  public ctlSeven = false;
  public ctlEight = false;
  public ctlNine = false;
  public ctlTen = false;
  public showTimer = false;
  public dateData = '';
  public reminderEditId: any;
  public editModeBg = false;
  public showMobile = false;
  public isPremium;
  public arrangeAddingTasks = 'به اول لیست کارها';
  public allTasksAreCompleted = false;
  public filteredCategory: Observable<Category[]>;
  public hi;
  public pomodoroNotification = {
    type: 'pomodoro',
    device_token: localStorage.getItem('device_token'),
  };
  public shortRestNotification = {
    type: 'shortRest',
    device_token: localStorage.getItem('device_token'),
  };
  public longRestNotification = {
    type: 'longRest',
    device_token: localStorage.getItem('device_token'),
  };
  public fireDeviceToken = {
    device_token: localStorage.getItem('device_token'),
  };
  public pomoSoundsInNoneLoginMode: Sound[] = [
    new Sound(
      1,
      'صدای شماره یک',
      '../../assets/sounds/countdown_10sec_effects.mp3',
      true
    ),
    new Sound(
      2,
      'صدای شماره دو',
      '../../assets/sounds/cute_metallic_ui_button_pr__.mp3',
      false
    ),
    new Sound(
      3,
      'صدای شماره سه',
      '../../assets/sounds/death_game_over_1.mp3',
      false
    ),
    new Sound(
      4,
      'صدای شماره چهار',
      '../../assets/sounds/startup_18.mp3',
      false
    ),
    new Sound(
      5,
      'صدای شماره پنج',
      '../../assets/sounds/ui-glass_ticks-16-wav.mp3',
      false
    ),
  ];
  public breakSoundsInNoneLoginMode: Sound[] = [
    new Sound(
      1,
      'صدای شماره یک',
      '../../assets/sounds/countdown_10sec_effects.mp3',
      false
    ),
    new Sound(
      2,
      'صدای شماره دو',
      '../../assets/sounds/cute_metallic_ui_button_pr__.mp3',
      false
    ),
    new Sound(
      3,
      'صدای شماره سه',
      '../../assets/sounds/death_game_over_1.mp3',
      true
    ),
    new Sound(
      4,
      'صدای شماره چهار',
      '../../assets/sounds/startup_18.mp3',
      false
    ),
    new Sound(
      5,
      'صدای شماره پنج',
      '../../assets/sounds/ui-glass_ticks-16-wav.mp3',
      false
    ),
  ];
  public pomoSounds = [];
  public breakSounds = [];
  public pomodoroSound: Sound = new Sound(
    1,
    'صدای شماره یک',
    '../../assets/sounds/countdown_10sec_effects.mp3',
    true
  );
  public breakSound: Sound = new Sound(
    3,
    'صدای شماره سه',
    '../../assets/sounds/death_game_over_1.mp3',
    true
  );
  public defaultFlag = 'assets/image/persian.png';
  public defaultFlagName = 'فارسی';
  public prevLang: any;
  public ltrDirection = false;
  public pomodoroAudio = new Audio();
  public breakAudio = new Audio();
  public setting: Setting = new Setting();
  protected categoryService: CategoryService;
  protected taskService: TaskService;
  protected todoService: TodoService;
  protected soundService: SoundService;
  protected settingService: SettingService;
  protected notificationService: NotificationService;
  protected ngNotification: PushNotificationsService;
  protected translateService: TranslateService;
  protected onlineService: OnlineService;
  public renderer: Renderer2;
  public router: Router;

  public static getInstance(injector): PomodoroRepository {
    if (PomodoroRepository.instance === null) {
      PomodoroRepository.instance = new PomodoroRepository(injector);
      return PomodoroRepository.instance;
    }
    return PomodoroRepository.instance;
  }

  intervalFunction(): any {
    const token = localStorage.getItem('token');
    this.pomodoroRemains = this.endTimestamp - moment().unix();
    if (this.pomodoroRemains > 0) {
      if (this.status === 'stop') {
        document.title = 'پومودوروی من | تکنیک مدیریت زمان';
      } else if (this.isBreak && this.status === 'start') {
        if (token != null) {
          document.title =
            '  استراحت  ' +
            (this.pomoCount - 1) +
            ' | ' +
            this.getTimerString();
        } else {
          // document.title = '  استراحت  ' + (this.todayPomodoroCount - 1) + ' | ' + this.getTimerString();
          document.title =
            '  استراحت  ' +
            (this.todayPomodoroCount - 1) +
            ' | ' +
            this.getTimerString();
        }
      } else if (!this.isBreak && this.status === 'start') {
        if (token != null) {
          document.title = '#' + this.pomoCount + ' | ' + this.getTimerString();
        } else {
          document.title =
            '#' + this.todayPomodoroCount + ' | ' + this.getTimerString();
        }
      }
      return;
    }
    let playP = false;
    let playB = false;
    // time ended
    if (this.status === 'start') {
      // timer was working. but is stop now
      if (this.isBreak) {
        // last session was break
        this.isBreak = false;
        this.status = 'stop';
        this.startTime = null;
        this.donePomodorosWhileTimeCounting = 0;
        if (this.sendRestNotification) {
          this.restPushNotification();
        }
        if (this.autoNextPomodoro) {
          if (this.todoPomodoros.length < 1) {
            this.allTasksAreCompleted = true;
            setTimeout(() => {
              this.allTasksAreCompleted = false;
            }, 3000);
          } else {
            const helper3 = this.todoPomodoros;
            this.todoPomodorosTopToBottom = helper3.sort((a, b) =>
              a.id < b.id ? -1 : 1
            );
            this.todoPomodorosBottomToTop = helper3.sort((a, b) =>
              a.id > b.id ? -1 : 1
            );
            // should start next break
            this.start();
          }
        }
        playB = true;
        if (this.isReversed === 'پایین به بالا') {
          this.isReversed = 'پایین به بالا';
          this.arrangeAddingTasks = 'به آخر لیست کارها';
          localStorage.setItem('arrangeAddingTasks', this.arrangeAddingTasks);
          localStorage.setItem('isReverse', this.isReversed);
          this.todoPomodorosBottomToTop = this.todoPomodoros.sort((a, b) =>
            a.id < b.id ? -1 : 1
          );
          localStorage.setItem(
            'todoPomodorosBottomToTop',
            JSON.stringify(
              this.todoPomodorosBottomToTop.sort((a, b) =>
                a.id < b.id ? -1 : 1
              )
            )
          );
          return this.todoPomodorosBottomToTop;
        }
      } else {
        // last session was pomodoro
        this.isBreak = true;
        this.pomodoroDoneEvent();
        this.donePomodorosWhileTimeCounting++;
        // this.getTokenDoneTime();
        this.pomoCount++;
        setTimeout(() => {
          this.online();
        }, 500);
        if (this.sendPomodoroNotification) {
          this.pomodoroPushNotification();
        }
        if (this.autoNextBreak) {
          // should start break automatically
          // tslint:disable-next-line:max-line-length
          this.endTimestamp = moment()
            .add(
              (this.todayPomodoroCount - 1) % this.defaultCount === 0
                ? this.longBreak
                : this.shortBreak,
              'minutes'
            )
            .unix();
          this.status = 'start';
          setTimeout(() => {
            this.online();
          }, 500);
        } else {
          // stop the timer... waiting for starting break
          this.status = 'stop';
          this.donePomodorosWhileTimeCounting = 0;
          this.endTimestamp = null;
        }
        playP = true;
      }
      this.save();
    }
    if (playP) {
      this.playPomodoroSound();
    } else if (playB) {
      this.playBreakSound();
    }
    if (this.status === 'stop') {
      document.title = 'پومودوروی من | تکنیک مدیریت زمان';
    } else if (this.isBreak && this.status === 'start') {
      document.title = '  استراحت  ' + this.getTimerString();
    } else if (!this.isBreak && this.status === 'start') {
      document.title = '  پومودورو  ' + this.getTimerString();
    }
  }

  pomodoroDoneEvent(): any {
    this.getTokenDoneTime();
    this.todayPomodoroCount++;
    if (this.getTodoPomodoros().length > 0) {
      const p = this.getTodoPomodoros()[0];
      p.count--;
      const donePomodoro = new Pomodoro();
      donePomodoro.description = p.description;
      donePomodoro.category = p.category;
      donePomodoro.doneTime = moment().format('HH:mm');
      donePomodoro.ended_at = moment().format('YYYY-MM-DD HH:mm:ss');
      donePomodoro.done = true;
      donePomodoro.time_length = this.defaultMeasure;
      donePomodoro.id = this.index;
      this.index++;
      this.donePomodoros = [donePomodoro].concat(this.donePomodoros);
      // this.donePomodoros.push(donePomodoro);
      if (p.count === 0) {
        this.removeFromTodo(p, false);
      }
      if (this.isReversed === 'پایین به بالا') {
        this.isReversed = 'پایین به بالا';
        this.arrangeAddingTasks = 'به آخر لیست کارها';
        localStorage.setItem('arrangeAddingTasks', this.arrangeAddingTasks);
        localStorage.setItem('isReverse', this.isReversed);
        this.todoPomodorosBottomToTop = this.todoPomodoros.sort((a, b) =>
          a.id < b.id ? -1 : 1
        );
        localStorage.setItem(
          'todoPomodorosBottomToTop',
          JSON.stringify(
            this.todoPomodorosBottomToTop.sort((a, b) => (a.id < b.id ? -1 : 1))
          )
        );
        return this.todoPomodorosBottomToTop;
      }
    }
  }

  getDonePomoLengthFunc(): any {
    this.taskService.getTodayTask().subscribe((data) => {
      this.todaySumHour = data.sum_length;
      this.finalDone = moment()
        .startOf('day')
        .add(this.todaySumHour, 'minutes')
        .format('HH:mm');
    });
  }

  done(p): any {
    this.todayPomodoroCount++;
    this.pomoCount++;
    const donePomodoro = new Pomodoro();
    donePomodoro.description = p.description;
    donePomodoro.category = p.category;
    donePomodoro.doneTime = moment().format('HH:mm');
    donePomodoro.ended_at = moment().format('YYYY-MM-DD HH:mm:ss');
    donePomodoro.done = true;
    donePomodoro.time_length = this.defaultMeasure;
    donePomodoro.id = this.index;
    this.index++;
    if (p.count < 2) {
      this.removeFromTodo(p, false);
    } else {
      p.count--;
    }
    this.donePomodoros = [donePomodoro].concat(this.donePomodoros);
    // this.donePomodoros.push(donePomodoro);
    this.save();
    if (this.isReversed === 'پایین به بالا') {
      this.isReversed = 'پایین به بالا';
      this.arrangeAddingTasks = 'به آخر لیست کارها';
      localStorage.setItem('arrangeAddingTasks', this.arrangeAddingTasks);
      localStorage.setItem('isReverse', this.isReversed);
      this.todoPomodorosBottomToTop = this.todoPomodoros.sort((a, b) =>
        a.id < b.id ? -1 : 1
      );
      localStorage.setItem(
        'todoPomodorosBottomToTop',
        JSON.stringify(
          this.todoPomodorosBottomToTop.sort((a, b) => (a.id < b.id ? -1 : 1))
        )
      );
      return this.todoPomodorosBottomToTop;
    }
    // this.taskService.getTodayTask().subscribe(
    //   (data) => {
    //     this.todaySumHour = data.sum_length;
    //     this.finalDone = moment().startOf('day').add(this.todaySumHour, 'minutes').format('HH:mm');
    //     console.log(this.finalDone);
    //   }
    // );
  }

  start(): any {
    setTimeout(() => {
      this.online();
    }, 500);
    if (this.status === 'stop') {
      if (!this.isBreak) {
        // start pomodoro
        this.endTimestamp = moment().add(this.defaultMeasure, 'minutes').unix();
      } else {
        // start break
        this.endTimestamp = moment()
          .add(
            this.todayPomodoroCount % this.defaultCount === 0
              ? this.longBreak
              : this.shortBreak,
            'minutes'
          )
          .unix();
      }
      this.status = 'start';
      this.startTime = Date.now();
      const token = localStorage.getItem('token');
      if (token != null) {
        this.save();
      }
    }
  }

  restart(): any {
    this.endTimestamp = moment().add(this.defaultMeasure, 'minutes').unix();
    this.status = 'stop';
    this.donePomodorosWhileTimeCounting = 0;
    this.isBreak = false;
    this.startTime = null;
    const token = localStorage.getItem('token');
    if (token != null) {
      this.save();
      this.onlineRestart();
    }
  }

  reo(): any {
    return this.status === 'stop' && this.isBreak === false
      ? 'no-drop'
      : 'pointer';
  }

  getTimerString(): any {
    this.remainTest = this.endTimestamp - moment().unix();
    if (this.status === 'stop' || this.remainTest <= 0) {
      let minute = this.defaultMeasure;
      if (this.isBreak) {
        minute = this.shortBreak;
      }
      if (minute < 1) {
        minute = 2;
        return moment().startOf('day').add(minute, 'minutes').format('mm:ss');
      }
      if (minute > 0) {
        if (minute >= 60) {
          return moment.duration(minute, 'minutes').format('HH:mm:ss');
          // return moment().startOf('day').add(this.remainTest, 'seconds').format('HH:mm:ss');
        }
        return moment().startOf('day').add(minute, 'minutes').format('mm:ss');
      }
    }
    if (this.remainTest >= 3600) {
      // return moment.duration(this.defaultMeasure, 'minutes').format('HH:mm:ss');
      return moment()
        .startOf('day')
        .add(this.remainTest, 'seconds')
        .format('HH:mm:ss');
    }
    if (this.remainTest < 3600) {
      return moment()
        .startOf('day')
        .add(this.remainTest, 'seconds')
        .format('mm:ss');
    }
  }

  addItem(p: Pomodoro): any {
    if (p.description !== undefined || p.category !== undefined) {
      p.id = this.index;
      this.index++;
      p.created_at = moment().format('YYYY-MM-DD HH:mm:ss');
      p.time_length = this.defaultMeasure;
      // Add Task To Beginning or Ending Of Task List
      if (this.arrangeAddingTasks === 'به اول لیست کارها') {
        this.todoPomodoros.unshift(p);
        // this.todoPomodorosTopToBottom.unshift(p);
        localStorage.setItem(
          'todoPomodorosBottomToTop',
          JSON.stringify(this.todoPomodorosBottomToTop)
        );
        // this.todoPomodoros = this.todoPomodorosTopToBottom;
      } else if (this.arrangeAddingTasks === 'به آخر لیست کارها') {
        this.todoPomodoros.push(p);
        // this.todoPomodorosBottomToTop.push(p);
        localStorage.setItem(
          'todoPomodorosBottomToTop',
          JSON.stringify(this.todoPomodorosBottomToTop)
        );
        // this.todoPomodoros = this.todoPomodorosBottomToTop;
      }
      this.save();
    }
  }
  addToTodos(t: Todo): any {
    this.todoService.createTodo(t).subscribe((data) => {
      this.getListOfTodos();
    });
  }
  deleteTodos(id): any {
    this.todoService.deleteTodo(id).subscribe(() => {
      this.getListOfTodos();
    });
  }
  getListOfTodos(): any {
    this.todoService.getListOfUsersTodo().subscribe((data) => {
      this.todosList = data.data;
      this.todoListIds = this.todosList.map((item) => item.id);
    });
  }

  deleteAllTodods(): any {
    const req = {
      ids: this.todoListIds,
    };
    this.todoService.deleteAllTodos(req).subscribe((data) => {
      this.getListOfTodos();
    });
  }

  listReturners(): any {
    if (this.todosList === undefined) {
      return [];
    } else {
      return this.todosList;
    }
  }

  copyToTodo(p: Pomodoro): any {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.todoPomodoros.length; i++) {
      if (
        this.todoPomodoros[i].description === p.description &&
        this.todoPomodoros[i].category === p.category
      ) {
        this.todoPomodoros[i].count++;
        return;
      }
    }
    const copy = new Pomodoro();
    copy.count = 1;
    copy.description = p.description;
    copy.category = p.category;
    this.addItem(copy);
  }

  increaseCount(p: Pomodoro): any {
    p.count = p.count + 1;
    this.save();
  }

  decreaseCount(p: Pomodoro): any {
    if (p.count > 1) {
      p.count = p.count - 1;
      this.save();
    }
  }

  removeFromTodo(p: Pomodoro, sync = true): any {
    for (let i = 0; i < this.todoPomodoros.length; i++) {
      if (this.todoPomodoros[i].id === p.id) {
        this.todoPomodoros.splice(i, 1);
      }
    }
    this.todoPomodorosTopToBottom = this.todoPomodoros.sort((a, b) =>
      a.id < b.id ? -1 : 1
    );
    this.todoPomodorosBottomToTop = this.todoPomodoros.sort((a, b) =>
      a.id > b.id ? -1 : 1
    );
    this.save(sync);
  }

  removeFromDone(p: Pomodoro): any {
    if (!this.isLoggedIn()) {
      this.todayPomodoroCount--;
    }
    for (let i = 0; i < this.donePomodoros.length; i++) {
      if (this.donePomodoros[i].id === p.id) {
        this.donePomodoros.splice(i, 1);
      }
    }
    this.save();
  }

  removeFromCategory(myControl): any {
    const getIndex = this.categories.indexOf(myControl);
    this.categories.splice(getIndex, 1);
    this.save();
  }

  save(syncTasks = true): any {
    // this.getTokenDoneTime();
    if (syncTasks && this.isLoggedIn()) {
      let sum = this.todoPomodoros;
      sum = sum.concat(this.donePomodoros);
      this.taskService.syncTask(sum).subscribe((data) => {
        this.taskService.getTodayTask().subscribe(
          // tslint:disable-next-line:no-shadowed-variable
          (data) => {
            this.todaySumHour = data.sum_length;
            this.finalDone = moment()
              .startOf('day')
              .add(this.todaySumHour, 'minutes')
              .format('HH:mm');
            this.getTokenDoneTime();
          }
        );
      });
    }
    this.saveToLocalStorage();
  }

  isLoggedIn(): any {
    const token = localStorage.getItem('token');
    return token !== null;
  }

  saveToLocalStorage(): any {
    // if (this.isReversed === 'بالا به پایین'){
    //   return this.todoPomodoros.sort((a, b) => (a.id < b.id) ? -1 : 1);
    // } else if (this.isReversed === 'پایین به بالا'){
    //   return this.todoPomodoros.sort((a, b) => (a.id > b.id) ? -1 : 1);
    // }
    localStorage.setItem('pomodoroSound', JSON.stringify(this.pomodoroSound));
    localStorage.setItem('breakSound', JSON.stringify(this.breakSound));
    localStorage.setItem('todoPomodoros', JSON.stringify(this.todoPomodoros));
    localStorage.setItem(
      'todoPomodorosTopToBottom',
      JSON.stringify(this.todoPomodorosTopToBottom)
    );
    localStorage.setItem(
      'todoPomodorosBottomToTop',
      JSON.stringify(this.todoPomodorosBottomToTop)
    );
    localStorage.setItem(
      'donePomodoros_' + moment().format('YYYY-MM-DD'),
      JSON.stringify(this.donePomodoros)
    );
    for (let i = 0; i < this.categories.length; i++) {
      if (this.categories[i] === null) {
        this.categories = [
          ...this.categories.slice(0, i),
          ...this.categories.slice(i + 1),
        ];
      }
    }
    localStorage.setItem('categories', JSON.stringify(this.categories));
    localStorage.setItem(
      'todayPomodoroCount_' + moment().format('YYYY-MM-DD'),
      String(this.todayPomodoroCount)
    );
    localStorage.setItem('status', this.status);
    localStorage.setItem('index', String(this.index));
    localStorage.setItem('categoryIndex', String(this.categoryIndex));
    localStorage.setItem('isBreak', this.isBreak ? '1' : '0');
    localStorage.setItem('germanMode', this.germanMode ? '1' : '0');
    localStorage.setItem('darkMode', this.darkMode ? '1' : '0');
    localStorage.setItem('autoNextBreak', this.autoNextBreak ? '1' : '0');
    localStorage.setItem('autoNextPomodoro', this.autoNextPomodoro ? '1' : '0');
    localStorage.setItem(
      'sendPomodoroNotification',
      this.sendPomodoroNotification ? '1' : '0'
    );
    localStorage.setItem(
      'sendRestNotification',
      this.sendRestNotification ? '1' : '0'
    );
    localStorage.setItem(
      'beInPomodoroRanking',
      this.beInPomodoroRanking ? '1' : '0'
    );
    localStorage.setItem('endTimestamp', String(this.endTimestamp));
    localStorage.setItem('startTime', String(this.startTime));
    localStorage.setItem('defaultMeasure', String(this.defaultMeasure));
    localStorage.setItem('shortBreak', String(this.shortBreak));
    localStorage.setItem('longBreak', String(this.longBreak));
    localStorage.setItem('defaultPomoCount', String(this.defaultCount));
  }

  getTodoPomodoros(): any {
    // if (this.isReversed === 'بالا به پایین'){
    //   return this.todoPomodoros.sort((a, b) => (a.id < b.id) ? -1 : 1);
    // } else if (this.isReversed === 'پایین به بالا'){
    //   return this.todoPomodoros.sort((a, b) => (a.id > b.id) ? -1 : 1);
    // }
    // return this.todoPomodorosTopToBottom;
    return this.todoPomodoros;
    // return this.todoPomodoros.sort((a, b) => (a.id < b.id) ? -1 : 1);
  }
  getReversedTodoPomdoros(): any {
    return this.todoPomodorosBottomToTop;
  }
  getDonePomodoros(): any {
    if (this.donePomodoros === undefined) {
      return [];
    } else {
      return this.donePomodoros;
    }
  }

  getAllToDoPomodoro(): any {
    let sumOfPomo = 0;
    this.getTodoPomodoros().forEach((item) => {
      sumOfPomo += item.count;
    });
    return sumOfPomo;
  }

  getFirst(): any {
    return this.getTodoPomodoros().length > 0
      ? this.getTodoPomodoros()[0]
      : new Pomodoro();
  }

  getLast(): any {
    return this.getTodoPomodoros().length > 0
      ? this.getTodoPomodoros()[this.getTodoPomodoros().length - 1]
      : new Pomodoro();
  }

  getSumOfDurationsTodo(): any {
    let sumOfPomodoro = 0;
    this.getTodoPomodoros().forEach((item) => {
      sumOfPomodoro += item.count;
    });
    return moment()
      .startOf('day')
      .add(sumOfPomodoro * this.defaultMeasure, 'minutes')
      .format('HH:mm');
  }

  getPomoToDoDoneTime(p: Pomodoro): any {
    let sumOfPomodoro = 0;
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.todoPomodoros.length; i++) {
      sumOfPomodoro += this.todoPomodoros[i].count;
      if (this.todoPomodoros[i].id === p.id) {
        break;
      }
    }
    sumOfPomodoro += this.donePomodorosWhileTimeCounting;
    if (sumOfPomodoro === 0) {
      return '00:00';
    } else {
      return moment(this.startTime ? this.startTime : Date.now())
        .add(
          (sumOfPomodoro - 1) * this.shortBreak +
            // tslint:disable-next-line:max-line-length
            sumOfPomodoro * this.defaultMeasure +
            Math.floor((sumOfPomodoro - 1) / this.defaultCount) *
              (this.longBreak - this.shortBreak),
          'minutes'
        )
        .format('HH:mm');
    }
  }

  getSumOfDurationsDone(): any {
    let sumOfPomodoro = 0;
    this.getDonePomodoros().forEach((item) => {
      sumOfPomodoro += item.count;
    });
    return moment()
      .startOf('day')
      .add(sumOfPomodoro * this.defaultMeasure, 'minutes')
      .format('HH:mm');
  }

  getNextLongBreakTime(): any {
    if (this.isBreak && this.status === 'start') {
      if (this.userIsLoggedIn) {
        this.tcp = this.pomoCount;
        this.tcp = this.tcp + 2;
      } else {
        this.tcp = this.todayPomodoroCount;
        this.tcp--;
      }
      const longBreak = this.defaultCount - (this.tcp % this.defaultCount);
      // tslint:disable-next-line:max-line-length
      return moment(this.startTime ? this.startTime : Date.now())
        .add(
          longBreak * (this.defaultMeasure + this.shortBreak) - this.shortBreak,
          'minutes'
        )
        .format('HH:mm');
    } else {
      if (this.userIsLoggedIn) {
        this.tcp = this.pomoCount;
        this.tcp--;
      } else {
        this.tcp = this.todayPomodoroCount;
        this.tcp--;
      }
      const longBreak = this.defaultCount - (this.tcp % this.defaultCount);
      // tslint:disable-next-line:max-line-length
      return moment(this.startTime ? this.startTime : Date.now())
        .add(
          longBreak * (this.defaultMeasure + this.shortBreak) - this.shortBreak,
          'minutes'
        )
        .format('HH:mm');
    }
  }

  setPomodoroSound(sound: Sound): void {
    if (this.userIsLoggedIn) {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.pomoSounds.length; i++) {
        const index = this.pomoSounds.findIndex((item) => item.id === sound.id);
        if (this.pomoSounds[index].id === index) {
          this.pomoSounds[index].isSelected = true;
        } else if (this.pomoSounds[index].id !== index) {
          this.selectedPomoSound = [
            ...this.pomoSounds.slice(0, index),
            ...this.pomoSounds.slice(index + 1),
          ];
          // tslint:disable-next-line:prefer-for-of
          for (let p = 0; p < this.selectedPomoSound.length; p++) {
            this.selectedPomoSound[p].isSelected = false;
          }
        }
      }
      this.pomodoroAudio.src = sound.url;
      sound.isSelected = true;
      localStorage.setItem('pomoAudio', JSON.stringify(sound));
      this.pomodoroAudio.play().then();
      this.saveToLocalStorage();
      this.setting.pomodoro_sound_id = sound.id;
      this.pomodoroSoundId = sound.id;
      localStorage.setItem('pomodoro_sound_id', this.setting.pomodoro_sound_id);
    } else {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.pomoSoundsInNoneLoginMode.length; i++) {
        const index = this.pomoSoundsInNoneLoginMode.findIndex(
          (item) => item.id === sound.id
        );
        if (this.pomoSoundsInNoneLoginMode[index].id === index) {
          this.pomoSoundsInNoneLoginMode[index].isSelected = true;
        } else if (this.pomoSoundsInNoneLoginMode[index].id !== index) {
          this.selectedPomoSound = [
            ...this.pomoSoundsInNoneLoginMode.slice(0, index),
            ...this.pomoSoundsInNoneLoginMode.slice(index + 1),
          ];
          // tslint:disable-next-line:prefer-for-of
          for (let p = 0; p < this.selectedPomoSound.length; p++) {
            this.selectedPomoSound[p].isSelected = false;
          }
        }
      }
      this.pomodoroAudio.src = sound.soundEffect;
      sound.isSelected = true;
      localStorage.setItem('pomoAudio', JSON.stringify(sound));
      this.pomodoroAudio.play().then();
      this.saveToLocalStorage();
      localStorage.setItem(
        'PomodoroSoundsList',
        JSON.stringify(this.pomoSoundsInNoneLoginMode)
      );
      // this.setting.pomodoro_sound_id = sound.id;
    }
  }

  setBreakSound(sound: Sound): void {
    if (this.userIsLoggedIn) {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.breakSounds.length; i++) {
        const index = this.breakSounds.findIndex(
          (item) => item.id === sound.id
        );
        if (this.breakSounds[index].id === index) {
          this.breakSounds[index].isSelected = true;
        } else if (this.breakSounds[index].id !== index) {
          this.selectedBreakSound = [
            ...this.breakSounds.slice(0, index),
            ...this.breakSounds.slice(index + 1),
          ];
          // tslint:disable-next-line:prefer-for-of
          for (let p = 0; p < this.selectedBreakSound.length; p++) {
            this.selectedBreakSound[p].isSelected = false;
          }
        }
      }
      this.breakAudio.src = sound.url;
      sound.isSelected = true;
      localStorage.setItem('breakAudio', JSON.stringify(sound));
      this.breakAudio.play().then();
      this.saveToLocalStorage();
      localStorage.setItem('BreakSoundsList', JSON.stringify(this.breakSounds));
      this.setting.rest_sound_id = sound.id;
      this.restSoundId = sound.id;
      localStorage.setItem('rest_sound_id', this.setting.rest_sound_id);
    } else {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.breakSoundsInNoneLoginMode.length; i++) {
        const index = this.breakSoundsInNoneLoginMode.findIndex(
          (item) => item.id === sound.id
        );
        if (this.breakSoundsInNoneLoginMode[index].id === index) {
          this.breakSoundsInNoneLoginMode[index].isSelected = true;
        } else if (this.breakSoundsInNoneLoginMode[index].id !== index) {
          // tslint:disable-next-line:max-line-length
          this.selectedBreakSound = [
            ...this.breakSoundsInNoneLoginMode.slice(0, index),
            ...this.breakSoundsInNoneLoginMode.slice(index + 1),
          ];
          // tslint:disable-next-line:prefer-for-of
          for (let p = 0; p < this.selectedBreakSound.length; p++) {
            this.selectedBreakSound[p].isSelected = false;
          }
        }
      }
      this.breakAudio.src = sound.soundEffect;
      sound.isSelected = true;
      localStorage.setItem('breakAudio', JSON.stringify(sound));
      this.breakAudio.play().then();
      this.saveToLocalStorage();
      localStorage.setItem(
        'BreakSoundsList',
        JSON.stringify(this.breakSoundsInNoneLoginMode)
      );
    }
  }

  playPomodoroSound(): void {
    if (JSON.parse(localStorage.getItem('pomoAudio')) === null) {
      const selectedPomoSound = this.pomoSoundsInNoneLoginMode[1];
      this.pomodoroAudio.src = selectedPomoSound.soundEffect;
      this.pomodoroAudio.play().then();
    } else {
      const selectedPomoSound = JSON.parse(localStorage.getItem('pomoAudio'));
      this.pomodoroAudio.src = selectedPomoSound.url;
      this.pomodoroAudio.play().then();
    }
  }

  playBreakSound(): void {
    const selectedBreakSound = JSON.parse(localStorage.getItem('breakAudio'));
    this.breakAudio.src = selectedBreakSound.url;
    this.breakAudio.play().then();
  }

  updateSetting(): any {
    this.settingService.updateSetting(this.setting).subscribe();
  }

  pomodoroPushNotification(): any {
    Notification.requestPermission((permission) => {
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification('وقت استراحت', {
          body: 'کار بسه وقت استراحته :)',
          icon: 'http://i.stack.imgur.com/Jzjhz.png?s=48&g=1',
          dir: 'rtl',
        });
      });
    });
  }

  restPushNotification(): any {
    Notification.requestPermission((permission) => {
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification('وقت کاره', {
          body: 'استراحت بسه وقت کاره',
          icon: 'http://i.stack.imgur.com/Jzjhz.png?s=48&g=1',
          dir: 'rtl',
        });
      });
    });
  }

  permissionNotification(): any {
    this.ngNotification.requestPermission();
  }

  farsiLang(): any {
    this.translateService.use('fa');
    localStorage.setItem('trans', 'fa');
    this.defaultFlag = 'assets/image/persian.png';
    this.defaultFlagName = 'فارسی';
    this.ltrDirection = false;
    localStorage.setItem('dir', 'rtl');
    this.clickToggle = false;
    this.arabicMode = false;
    this.germanMode = false;
    this.spRuMode = false;
    this.showMobile = false;
    this.changeAllCategoryName();
  }

  englishLang(): any {
    this.translateService.use('en');
    localStorage.setItem('trans', 'en');
    this.defaultFlag = 'assets/image/english.png';
    this.defaultFlagName = 'English';
    this.ltrDirection = true;
    localStorage.setItem('dir', 'ltr');
    this.clickToggle = false;
    this.arabicMode = false;
    this.germanMode = false;
    this.spRuMode = false;
    this.showMobile = false;
    this.changeAllCategoryName();
  }

  italianLang(): any {
    this.translateService.use('it');
  }

  arabianLang(): any {
    this.translateService.use('ar');
    localStorage.setItem('trans', 'ar');
    this.defaultFlag = 'assets/image/arabic.png';
    this.defaultFlagName = 'العربیة';
    this.ltrDirection = false;
    localStorage.setItem('dir', 'rtl');
    this.clickToggle = false;
    this.arabicMode = true;
    this.germanMode = false;
    this.spRuMode = false;
    this.showMobile = false;
    this.changeAllCategoryName();
  }

  deutschLang(): any {
    this.translateService.use('du');
    localStorage.setItem('trans', 'du');
    this.defaultFlag = 'assets/image/german.png';
    this.defaultFlagName = 'Deutsch';
    this.ltrDirection = true;
    localStorage.setItem('dir', 'ltr');
    this.clickToggle = false;
    this.germanMode = true;
    this.arabicMode = false;
    this.spRuMode = false;
    this.showMobile = false;
    this.changeAllCategoryName();
  }

  hindiLang(): any {
    this.translateService.use('hi');
    localStorage.setItem('trans', 'hi');
    this.defaultFlag = 'assets/image/indian.png';
    this.defaultFlagName = 'हिन्दी\n';
    this.ltrDirection = true;
    localStorage.setItem('dir', 'ltr');
    this.clickToggle = false;
    this.arabicMode = false;
    this.germanMode = false;
    this.spRuMode = false;
    this.showMobile = false;
    this.changeAllCategoryName();
  }

  russianLang(): any {
    this.translateService.use('ru');
    localStorage.setItem('trans', 'ru');
    this.defaultFlag = 'assets/image/russian.png';
    this.defaultFlagName = 'Русский\n';
    this.ltrDirection = true;
    localStorage.setItem('dir', 'ltr');
    this.clickToggle = false;
    this.arabicMode = false;
    this.germanMode = false;
    this.spRuMode = true;
    this.showMobile = false;
    this.changeAllCategoryName();
  }

  spanishLang(): any {
    this.translateService.use('sp');
    localStorage.setItem('trans', 'sp');
    this.defaultFlag = 'assets/image/spanish.png';
    this.defaultFlagName = 'Español';
    this.ltrDirection = true;
    localStorage.setItem('dir', 'ltr');
    this.clickToggle = false;
    this.arabicMode = false;
    this.germanMode = false;
    this.spRuMode = true;
    this.showMobile = false;
    this.changeAllCategoryName();
  }

  franceLang(): any {
    this.translateService.use('fr');
  }

  openMenu(): any {
    this.clickToggle = !this.clickToggle;
  }

  // getDoneDurationTime(): any{
  //
  // }
  getTokenDoneTime(): any {
    // console.log(lo);
    const token = localStorage.getItem('token');
    if (token !== null) {
      this.taskService.getTodayTask().subscribe(
        (data) => {
          this.pomoCount = ++data.sum_count;
          this.getTodayProp = data.data.done;
          this.todaySumHour = data.sum_length;
          this.finalDone = moment()
            .startOf('day')
            .add(this.todaySumHour, 'minutes')
            .format('HH:mm');
        },
        (err) => {
          if (err.status === 500 && err.error === 'Unauthenticated.') {
            this.prevLang = localStorage.getItem('trans');
            localStorage.clear();
            localStorage.setItem('trans', this.prevLang);
            this.userIsLoggedIn = false;
            this.router.navigateByUrl('/login').then();
          }
        }
      );
    } else {
      return;
    }
  }

  changeAllCategoryName(): any {
    if (localStorage.getItem('trans') === 'fa') {
      this.allCategory = 'همه دسته بندی ها';
    } else if (localStorage.getItem('trans') === 'en') {
      this.allCategory = 'All Categories';
    } else if (localStorage.getItem('trans') === 'ar') {
      this.allCategory = 'كافة التصنيفات';
    } else if (localStorage.getItem('trans') === 'sp') {
      this.allCategory = 'Todas las categorías';
    } else if (localStorage.getItem('trans') === 'du') {
      this.allCategory = 'Alle Kategorien';
    } else if (localStorage.getItem('trans') === 'ru') {
      this.allCategory = 'Все категории';
    } else if (localStorage.getItem('trans') === 'hi') {
      this.allCategory = 'सभी दस्ते बन्दी ';
    }
  }

  navigateToProfile(): any {
    this.router.navigateByUrl('/profile').then(() => {
      this.showMobile = false;
    });
  }

  navigateToLogin(): any {
    this.router.navigateByUrl('/login').then(() => {
      this.showMobile = false;
    });
  }

  navigateToPomodoroTimer(): any {
    this.router.navigateByUrl('/').then(() => {
      this.showMobile = false;
    });
  }

  navigateToStatistics(): any {
    this.router.navigateByUrl('/Statistics').then(() => {
      this.showMobile = false;
    });
  }

  navigateToSetting(): any {
    this.router.navigateByUrl('/setting').then(() => {
      this.showMobile = false;
    });
  }
  online(): any {
    if (
      localStorage.getItem('status') === 'start' &&
      localStorage.getItem('isBreak') === '0'
    ) {
      const sData = {
        time: Number(localStorage.getItem('defaultMeasure')),
        resting: false,
      };
      this.onlineService.online(sData).subscribe();
    }
    if (this.pomoCount % this.defaultCount === 1) {
      if (
        localStorage.getItem('status') === 'start' &&
        localStorage.getItem('isBreak') === '1'
      ) {
        const lbData = {
          time: Number(localStorage.getItem('longBreak')),
          resting: true,
        };
        this.onlineService.online(lbData).subscribe();
      }
    } else {
      if (
        localStorage.getItem('status') === 'start' &&
        localStorage.getItem('isBreak') === '1'
      ) {
        const sbData = {
          time: Number(localStorage.getItem('shortBreak')),
          resting: true,
        };
        this.onlineService.online(sbData).subscribe();
      }
    }
  }
  onlineRestart(): any {
    const data = {
      time: 10,
      resting: false,
    };
    this.onlineService.online(data).subscribe();
  }
  getSoundFromApi(): any {
    this.soundService.getListOfSound().subscribe((data) => {
      this.pomoSounds = data.data;
      localStorage.setItem('apiPomoSound', JSON.stringify(this.pomoSounds));
      this.breakSounds = data.data;
      localStorage.setItem('apiBreakSound', JSON.stringify(this.breakSounds));
    });
  }
}
